import { PaymentMethodCode } from "@omni/types/components/payment/shared/enum/paymentMethodCode.enum";
import * as yup from "yup";

export const PaymentMethodsFormValidationSchema = yup.object({
    code: yup
        .mixed<PaymentMethodCode>()
        .oneOf(Object.values(PaymentMethodCode))
        .optional()
});

export type PaymentMethodsFormValues = yup.InferType<
    typeof PaymentMethodsFormValidationSchema
>;
